export default __webpack_public_path__ + "static/media/san-diego.7aeaae56.png";